module.exports = __webpack_public_path__ + "img/document-img.97afa959.svg";